import { supabase } from '@/integrations/supabase/client';

/**
 * Lifecycle event types accepted by the `audit-mfa-event` Edge Function.
 * Server-side validates against this exact list.
 */
export type MfaLifecycleEvent =
  | 'mfa.factor_enrolled'
  | 'mfa.factor_verified'
  | 'mfa.factor_unenrolled.self'
  | 'mfa.factor_enroll_cancelled';

interface AuditMfaEventInput {
  eventType: MfaLifecycleEvent;
  factorId?: string | null;
  note?: string;
}

/**
 * Best-effort: emit an MFA factor lifecycle audit row. Failures are logged
 * but do not surface to the user — losing a single audit row must never
 * block a security action that already succeeded server-side. The edge
 * function captures the user's verified identity from the JWT, so even if
 * a malicious client lies about the event_type, attribution is correct.
 */
export async function emitMfaLifecycleEvent(
  input: AuditMfaEventInput,
): Promise<void> {
  try {
    const { error } = await supabase.functions.invoke('audit-mfa-event', {
      body: {
        event_type: input.eventType,
        factor_id: input.factorId ?? null,
        note: input.note,
      },
    });
    if (error) {
      console.warn('[audit-mfa-event] emission failed', {
        eventType: input.eventType,
        error: error.message,
      });
    }
  } catch (err) {
    console.warn('[audit-mfa-event] emission threw', {
      eventType: input.eventType,
      error: err instanceof Error ? err.message : String(err),
    });
  }
}
